import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
// import cookie from 'react-cookies'
import { Button, TextField, Select, MenuItem } from '@material-ui/core/';
import InputLabel from '@material-ui/core/InputLabel';
import Autocomplete from '@material-ui/lab/Autocomplete';
// import TextField from '@material-ui/core/TextField';
import cookie from 'react-cookies';
import {
  getAuditedListByUser,
  fetchQATranscriptionAudio,
  setPageName,
  superQAAudioDecision,
  fetchRejectReajonList,
  fetchEnglishKeywords,
  saveKeywordSuggestions,
} from '../../../service/action/audio-track-action';
import { Loader, DatePicker } from '../../../Components';
import FormControl from '@material-ui/core/FormControl';

class CreateKeyword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      keywordList: [],
      keyword: '',
      suggestions: [],
      user_id: '',
      pageNumber: 1,
      records: {},
      recordsError: {},
      transcriptText: '',
      model: false,
      notified: false,
      disableSubmit: true,
      showSuggestionField: false,
    };
    // this.rederAudioFiles = this.rederAudioFiles.bind(this)
    this.handleOnChange = this.handleOnChange.bind(this);
  }
  componentWillReceiveProps(nextProps) {
    // console.log(nextProps)
    // console.log(this.props)
    console.log('Receive props', nextProps);
    const { records, recordsError } = this.state;

    if (!nextProps.CreatorDashboardReducer.loading) {
      records.keyword = '';
      records.suggestions = [];
      recordsError.keyword = '';
      this.setState({ records, recordsError });
    }
    // this.props.fetchEnglishKeywords()
  }

  componentWillMount() {
    this.props.setPageName('Keyword Generator');
    this.props.fetchEnglishKeywords(cookie.load('username'));
  }


  onSelectKeyword(e, key, value) {
    const { records } = this.state;
    records[key] = value;
    this.setState({ records, showSuggestionField: true });

  }

  handleOnChange(e, key, value) {
    const { records, recordsError } = this.state;
    records[key] = value;
    this.setState({ records, recordsError });
    if (records.suggestions.length > 0) {
      this.setState({ disableSubmit: false });
    } else {
      this.setState({ disableSubmit: true });
    }
  }

  onSubmit() {
    const { records } = this.state;
    this.props.saveKeywordSuggestions({
      keyword: records.keyword,
      possibleWords: records.suggestions,
      userId: cookie.load('username'),
    });
    this.setState({ showSuggestionField: false, disableSubmit: true });
    this.props.fetchEnglishKeywords(cookie.load('username'));
  }


  render() {
    const {
      CreatorDashboardReducer: { loading, keywordList, success },
    } = this.props;
    const {
      filterValues,
      user_id,
      keyword,
      records,
      suggestions,
      disableSubmit,
      showSuggestionField
    } = this.state;

    return (
      <div className='audio-to-trans-page superqa_team'>
        {/* <PlayCircleFilledIcon />
                            <p style={{ paddingLeft: 10 }}>{item.file_path.replace(`http://10.101.1.134/rec/`, ``)}</p> */}
        {/* {this.state.model ? this.renderRejectReasonModel() : null} */}
        {loading ? (
          <Loader />
        ) : (
          <div className='audio-result-contnet keyword-suggestions-container'>
            <div className='form-control'>
              <FormControl>
                <InputLabel id='ChooseKeyword'>Choose keyword</InputLabel>
                <Select
                  labelId='ChooseKeyword'
                  id='outlined-multiline-static-language'
                  label={`Choose Keyword`}
                  name='keyword'
                  value={records.keyword}
                  onChange={(e) =>
                    this.onSelectKeyword(e, 'keyword', e.target.value)
                  }
                  variant='outlined'
                >
                  {keywordList && keywordList.data
                    ? keywordList.data.map((keywordItem, i) => (
                      <MenuItem
                        key={i}
                        value={keywordItem.keyword_id}
                        label={keywordItem.keyword}
                      >
                        {keywordItem.keyword}
                      </MenuItem>
                    ))
                    : ''}
                </Select>
              </FormControl>
            </div>
            {showSuggestionField &&
              <div className='form-control'>
                <Autocomplete
                  multiple
                  id='tags-filled'
                  options={[]}
                  defaultValue={suggestions}
                  value={records.suggestions}
                  freeSolo
                  onChange={(e, value) => {
                    this.handleOnChange(e, 'suggestions', value);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant='filled'
                      label='Keyword suggestions'
                      placeholder='Keywords'
                    />
                  )}
                />
              </div>}
            <Button
              disabled={disableSubmit}
              onClick={() => {
                this.onSubmit()
              }}
              variant='contained'
              color='primary'
            >
              Submit
            </Button>
            {/* <p style={{ textAlign: "center", padding: 20 }}>Enter the File name to dispaly the Audio files.</p> */}
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { userLogin, CreatorDashboardReducer } = state;
  //const { QAManagement, loading, success, error } = state.AudioToTrackReducer

  return {
    CreatorDashboardReducer,
    //loading,
    userLogin,
    //success,
    //error
  };
}

export default withRouter(
  connect(mapStateToProps, {
    getAuditedListByUser,
    fetchQATranscriptionAudio,
    setPageName,
    superQAAudioDecision,
    fetchRejectReajonList,
    fetchEnglishKeywords,
    saveKeywordSuggestions,
  })(CreateKeyword)
);
